import { Component, inject } from '@angular/core';

import { BuscadorGeneralComponent } from '../buscador-general/buscador-general.component';
import { CargarConfService } from '../../../services/cargar-conf.service';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-carrucel',
    imports: [BuscadorGeneralComponent,CommonModule],
    templateUrl: './carrucel.component.html',
    styleUrl: './carrucel.component.css'
})
export class CarrucelComponent {
    public _conf = inject(CargarConfService);

    public listImg: number[] = [];
    public numImg: number = environment.carrucel_n_img; // Numero de imagenes que se muestran en el carrucel
    public incCont: number = 1;
    public idInterval: any;
    public showImg: string = '';

    public home_avatar: string =  `assets/redi/img/home_${environment.portal}_avatar.webp`;

    public ruta_images: string = environment.carrucel_ruta_img;


    ngOnInit(): void {
        for (let index = 1; index <= this.numImg; index++) {
            this.listImg.push(index)
        }
        this.init();
    }
    init() {

        this.showImg = `${this.ruta_images}${this.incCont}.webp`
        this.initTimer();
    }

    viewImg(img: number) {
        clearInterval(this.idInterval);
        this.incCont = img,
            this.showImg = `${this.ruta_images}${this.incCont}.webp`
        this.initTimer();
    }

    initTimer() {
        if (this.numImg === 1) {
            return; // No images to show
        }
        this.idInterval = setInterval(() => {//Intervalo de tiempo
            if (this.incCont < this.numImg) {
                this.incCont++
            } else {
                this.incCont = 1
            }
            this.showImg = `${this.ruta_images}${this.incCont}.webp`
        }, 5000);
    }
    ngOnDestroy() {
        if (this.idInterval) {
            clearInterval(this.idInterval);
        }
    }


    get existenDatos(): boolean {
        return (this._conf.dataGlobal?.asignaturas?.length ?? 0) > 0
            || (this._conf.dataGlobal?.grados?.length ?? 0) > 0;
    }
}
